import React, { useEffect, useState } from 'react';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import Footer from '../../components/Layout/Footer';
import BackToTop from '../../components/elements/BackToTop';
import AboutHero from './AboutHero';
import AboutContent from './AboutContent';
import OrganizingTeam from './OrganizingTeam';

const AboutUsPage = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 300);
        document.addEventListener('scroll', handleScroll);
        return () => document.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <AboutHero />
            <AboutContent />
            <OrganizingTeam />
            <BackToTop scroll={isVisible} />
            <Footer />
        </div>
    );
};

export default AboutUsPage;
